import React, { useState, useEffect } from "react";
import { API_URL, BASE_URL } from "../../../constants";
import "bootstrap/dist/css/bootstrap.min.css";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { Container, Row, Modal } from "react-bootstrap";
import dayjs from "dayjs";
import { Button } from "@mui/base";
import Stack from "@mui/material/Stack";
import { Tooltip } from "@mui/material";
import { GoogleMap, MarkerF } from "@react-google-maps/api";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Checkbox, FormControlLabel } from "@mui/material";
import { displayNotification } from "../../../helpers";

const RiderRegistration = () => {
  const navigate = useNavigate();
  const userToken = useSelector((s) => s.login.data.token);
  const [addNewStart, setAddNewStart] = useState(false);
  const [addNewStartDropdown, setAddNewStartDropdown] = useState(true);
  const [addNewStartField, setAddNewStartField] = useState(true);
  const [addNewEnd, setAddNewEnd] = useState(false);
  const [addNewEndDropdown, setAddNewEndDropdown] = useState(true);
  const [addNewEndField, setAddNewEndField] = useState(true);
  const [daysSelected, setDaysSelected] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // For Registration
  const [validated, setValidated] = useState(false);
  const [homeTimeSlots, setHomeTimeSlots] = useState([]);
  const [selectedHomeTime, setSelectedHomeTime] = useState("");
  const [selectedHomeTimeValue, setSelectedHomeTimeValue] = useState("");
  const [filteredOfficeTimeSlots, setFilteredOfficeTimeSlots] = useState([]);
  const [officeTimeSlots, setOfficeTimeSlots] = useState([]);
  const [selectedOfficeTime, setSelectedOfficeTime] = useState("");
  const [gender, setGender] = useState("");
  const [preferredGender, setPreferredGender] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const selectedDateFormat = selectedDate
    ? selectedDate.format("DD-MM-YYYY")
    : "";
  const [martialStatus, setMartialStatus] = useState("");
  const [education, setEducation] = useState("");
  const [profession, setProfession] = useState("");
  const [cnic, setCnic] = useState("");
  const [isValidCnic, setIsValidCnic] = useState(true);
  const [cnicFront, setCnicFront] = useState(null);
  const [cnicFrontExt, setCnicFrontExt] = useState(null);
  const [cnicBack, setCnicBack] = useState(null);
  const [cnicBackExt, setCnicBackExt] = useState(null);
  const [picture, setPicture] = useState(null);
  const [pictureExt, setPictureExt] = useState(null);
  // For Start Point
  const [locationStartString, setLocationStartString] = useState("");
  const [locationStartStringId, setLocationStartStringId] = useState("");
  const [locationStartStringField, setLocationStartStringField] =
    useState(locationStartString);
  const [dropdownStartdata, setDropDownStartData] = useState();
  const [provinceStartId, setProvinceStartId] = useState("");
  const [selectedStartProvinceCities, setSelectedStartProvinceCities] =
    useState([]);
  const [cityStart, setCityStart] = useState("");
  const [cityStartId, setCityStartId] = useState("");
  const [selectedStartCityArea, setSelectedStartCityArea] = useState([]);
  // For End Point
  const [locationEndString, setLocationEndString] = useState("");
  const [locationEndStringId, setLocationEndStringId] = useState("");
  const [locationEndStringField, setLocationEndStringField] =
    useState(locationEndString);
  const [dropdownEnddata, setDropDownEndData] = useState();
  const [provinceEndId, setProvinceEndId] = useState("");
  const [selectedEndProvinceCities, setSelectedEndProvinceCities] = useState([]);
  const [cityEnd, setCityEnd] = useState("");
  const [cityEndId, setCityEndId] = useState("");
  const [selectedEndCityArea, setSelectedEndCityArea] = useState([]);
  // For Start Point
  const [defaultStartCenter, setDefaultStartCenter] = useState({
    lat: 30.3753,
    lng: 69.3451,
  });
  const [markerPositionStart, setMarkerPositionStart] = useState({
    lat: null,
    lng: null,
  });
  // For End Point
  const [defaultEndCenter, setDefaultEndCenter] = useState({
    lat: 30.3753,
    lng: 69.3451,
  });
  const [markerPositionEnd, setMarkerPositionEnd] = useState({
    lat: null,
    lng: null,
  });
  // For Modals
  const [showStartModal, setShowStartModal] = useState(false);
  const [showEndModal, setShowEndModal] = useState(false);
  // For Autocomplete Suggestions
  const [startSuggestions, setStartSuggestions] = useState([]);
  const [endSuggestions, setEndSuggestions] = useState([]);

  // Initialize Services
  const autocompleteService = new window.google.maps.places.AutocompleteService();
  const geocoder = new window.google.maps.Geocoder();

  // Fetch autocomplete suggestions using AutocompleteService
  const getAutoComplete = async (value, isOrigin) => {
    let cityName, cityLat, cityLon;
    if (isOrigin) {
      const selectedCity = dropdownStartdata?.countries[0]?.provinces
        ?.find((province) => province.id == provinceStartId)
        ?.cities?.find((city) => city.id == cityStartId);
      cityName = selectedCity?.value;
      cityLat = selectedCity?.latitude || 33.6844; // Fallback to Rawalpindi
      cityLon = selectedCity?.longitude || 73.0479; // Fallback to Rawalpindi
    } else {
      const selectedCity = dropdownEnddata?.countries[0]?.provinces
        ?.find((province) => province.id == provinceEndId)
        ?.cities?.find((city) => city.id == cityEndId);
      cityName = selectedCity?.value;
      cityLat = selectedCity?.latitude || 33.6844; // Fallback to Rawalpindi
      cityLon = selectedCity?.longitude || 73.0479; // Fallback to Rawalpindi
    }

    if (!cityName || !value) {
      if (isOrigin) setStartSuggestions([]);
      else setEndSuggestions([]);
      return;
    }

    try {
      const request = {
        input: `${cityName} ${value}`,
        location: new window.google.maps.LatLng(cityLat, cityLon),
        radius: 20000, // 20km radius to match mobile
        strictBounds: true,
        componentRestrictions: { country: "PK" },
      };

      autocompleteService.getPlacePredictions(request, (predictions, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
          const suggestions = predictions.map((pred) => ({
            description: pred.description,
            place_id: pred.place_id,
          }));
          if (isOrigin) {
            setStartSuggestions(suggestions);
          } else {
            setEndSuggestions(suggestions);
          }
        } else {
          console.error("Error fetching autocomplete:", status);
          if (isOrigin) setStartSuggestions([]);
          else setEndSuggestions([]);
        }
      });
    } catch (error) {
      console.error("Error fetching autocomplete:", error);
      if (isOrigin) setStartSuggestions([]);
      else setEndSuggestions([]);
    }
  };

  // Debounce autocomplete requests
  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

  const debouncedGetAutoComplete = debounce(getAutoComplete, 300);

  useEffect(() => {
    if (selectedHomeTimeValue) {
      const filteredYears = homeTimeSlots.filter((time) => {
        const selectedTime = new Date(`01/01/2000 ${selectedHomeTimeValue}`);
        const currentTime = new Date(`01/01/2000 ${time.time_string}`);
        return currentTime > selectedTime;
      });
      setFilteredOfficeTimeSlots(filteredYears);
    } else {
      setFilteredOfficeTimeSlots(homeTimeSlots);
    }
  }, [selectedHomeTimeValue]);

  useEffect(() => {
    getdropdownStartdata();
  }, []);

  useEffect(() => {
    if (provinceStartId) {
      const selectedStartProvince =
        dropdownStartdata?.countries[0]?.provinces.find(
          (province) => province.id == provinceStartId
        );
      setSelectedStartProvinceCities(
        selectedStartProvince ? selectedStartProvince.cities : []
      );
    }
  }, [provinceStartId]);

  useEffect(() => {
    if (provinceEndId) {
      const selectedEndProvince = dropdownEnddata?.countries[0]?.provinces.find(
        (province) => province.id == provinceEndId
      );
      setSelectedEndProvinceCities(
        selectedEndProvince ? selectedEndProvince.cities : []
      );
    }
  }, [provinceEndId]);

  useEffect(() => {
    if (cityStartId) {
      const filteredStartCities = dropdownStartdata?.area?.filter(
        (city) => city.parent_id == cityStartId
      );
      const citystring = selectedStartProvinceCities?.filter(
        (city) => city.id == cityStartId
      );
      setLocationStartString(citystring[0]?.value || "");
      setSelectedStartCityArea(filteredStartCities ? filteredStartCities : []);
    }
  }, [cityStartId]);

  useEffect(() => {
    if (cityEndId) {
      const filteredEndCities = dropdownEnddata?.area?.filter(
        (city) => city.parent_id == cityEndId
      );
      const citystring = selectedEndProvinceCities?.filter(
        (city) => city.id == cityEndId
      );
      setLocationEndString(citystring[0]?.value || "");
      setSelectedEndCityArea(filteredEndCities ? filteredEndCities : []);
    }
  }, [cityEndId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [navigate]);

  useEffect(() => {
    if (locationStartString) {
      geocoder.geocode({ address: locationStartString }, (results, status) => {
        if (status === "OK" && results.length > 0) {
          const { lat, lng } = results[0].geometry.location;
          setDefaultStartCenter({ lat: lat(), lng: lng() });
        } else {
          console.error("Geocoding API response error");
        }
      });
    }
  }, [locationStartString]);

  useEffect(() => {
    if (locationEndString) {
      geocoder.geocode({ address: locationEndString }, (results, status) => {
        if (status === "OK" && results.length > 0) {
          const { lat, lng } = results[0].geometry.location;
          setDefaultEndCenter({ lat: lat(), lng: lng() });
        } else {
          console.error("Geocoding API response error");
        }
      });
    }
  }, [locationEndString]);

  const getdropdownStartdata = async () => {
    try {
      const response = await fetch(`${API_URL}/api/v1/list/data`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const jsonresponse = await response.json();
      setDropDownStartData(jsonresponse);
      setDropDownEndData(jsonresponse);
      setHomeTimeSlots(jsonresponse.time_slots);
      setOfficeTimeSlots(jsonresponse.time_slots);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleProvinceStartChange = (event) => {
    setCityStartId("");
    setLocationStartStringField("");
    setProvinceStartId(event.target.value);
    setStartSuggestions([]);
  };

  const handleProvinceEndChange = (event) => {
    setCityEndId("");
    setLocationEndStringField("");
    setProvinceEndId(event.target.value);
    setEndSuggestions([]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity()) {
      await handleLogin();
    } else {
      setValidated(true);
      displayNotification("error", "Please fill all required fields");
    }
  };

  const handleLocationStartField = (e) => {
    const value = e.target.value;
    setLocationStartStringField(value);
    setLocationStartString(value);
    if (value && cityStartId) {
      debouncedGetAutoComplete(value, true);
    } else {
      setStartSuggestions([]);
    }
  };

  const handleLocationEndField = (e) => {
    const value = e.target.value;
    setLocationEndStringField(value);
    setLocationEndString(value);
    if (value && cityEndId) {
      debouncedGetAutoComplete(value, false);
    } else {
      setEndSuggestions([]);
    }
  };

  const handleSuggestionSelect = async (suggestion, isOrigin) => {
    const { description, place_id } = suggestion;
    geocoder.geocode({ address: description }, (results, status) => {
      if (status === "OK" && results.length > 0) {
        const result = results[0];
        const isInCity = result.address_components?.some(
          (component) =>
            component.types.includes("locality") &&
            component.long_name.toLowerCase() === (isOrigin ? cityStart : cityEnd).toLowerCase()
        );
        if (isInCity || result.formatted_address.toLowerCase().includes((isOrigin ? cityStart : cityEnd).toLowerCase())) {
          const { lat, lng } = result.geometry.location;
          if (isOrigin) {
            setLocationStartStringField(description);
            setLocationStartString(description);
            setLocationStartStringId(place_id || "");
            setMarkerPositionStart({ lat: lat(), lng: lng() });
            setDefaultStartCenter({ lat: lat(), lng: lng() });
            setStartSuggestions([]);
            handleShowStartModal();
          } else {
            setLocationEndStringField(description);
            setLocationEndString(description);
            setLocationEndStringId(place_id || "");
            setMarkerPositionEnd({ lat: lat(), lng: lng() });
            setDefaultEndCenter({ lat: lat(), lng: lng() });
            setEndSuggestions([]);
            handleShowEndModal();
          }
        } else {
          displayNotification("error", `Please select a place in ${isOrigin ? cityStart : cityEnd}`);
        }
      } else {
        console.error("Geocoding API response error");
      }
    });
  };

  // const handleMapClickStart = (event) => {
  //   setMarkerPositionStart({
  //     lat: event.latLng.lat(),
  //     lng: event.latLng.lng(),
  //   });
  // };

  // const handleMapClickEnd = (event) => {
  //   setMarkerPositionEnd({
  //     lat: event.latLng.lat(),
  //     lng: event.latLng.lng(),
  //   });
  // };

    const handleMapClickStart = async (event) => {
  const lat = event.latLng.lat();
  const lng = event.latLng.lng();
  
  setMarkerPositionStart({ lat, lng });
  
  // Reverse geocode to get address string
  try {
    const response = await fetch(`
      https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyCrX4s2Y_jbtM-YZOmUwWK9m-WvlCu7EXA&result_type=street_address|route|neighborhood|locality
    `);
    
    const data = await response.json();
    
    if (data.status === 'OK' && data.results.length > 0) {
      // Find the most appropriate result within the city bounds
      const result = data.results.find(r => {
        const cityMatch = r.address_components.some(comp => 
          comp.types.includes('locality') && 
          comp.long_name.toLowerCase().includes(cityStart.toLowerCase())
        );
        return cityMatch;
      }) || data.results[0];
      
      const address = result.formatted_address;
      setLocationStartString(address);
      setLocationStartStringField(address);
      
      // Get place_id if available
      const placeId = result.place_id || '';
      setLocationStartStringId(placeId);
      
      console.log('Map clicked location:', address);
    } else {
      // Fallback: create a generic address string
      setLocationStartString(`Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`);
      setLocationStartStringField(`Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`);
    }
  } catch (error) {
    console.error('Error reverse geocoding:', error);
    // Fallback
    setLocationStartString(`Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`);
    setLocationStartStringField(`Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`);
  }
};

const handleMapClickEnd = async (event) => {
  const lat = event.latLng.lat();
  const lng = event.latLng.lng();
  
  setMarkerPositionEnd({ lat, lng });
  
  // Reverse geocode to get address string
  try {
    const response = await fetch(`
      https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyCrX4s2Y_jbtM-YZOmUwWK9m-WvlCu7EXA&result_type=street_address|route|neighborhood|locality
    `);
    
    const data = await response.json();
    
    if (data.status === 'OK' && data.results.length > 0) {
      // Find the most appropriate result within the city bounds
      const result = data.results.find(r => {
        const cityMatch = r.address_components.some(comp => 
          comp.types.includes('locality') && 
          comp.long_name.toLowerCase().includes(cityEnd.toLowerCase())
        );
        return cityMatch;
      }) || data.results[0];
      
      const address = result.formatted_address;
      setLocationEndString(address);
      setLocationEndStringField(address);
      
      // Get place_id if available
      const placeId = result.place_id || '';
      setLocationEndStringId(placeId);
      
      console.log('Map clicked location:', address);
    } else {
      // Fallback: create a generic address string
      setLocationEndString(`Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`);
      setLocationEndStringField(`Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`);
    }
  } catch (error) {
    console.error('Error reverse geocoding:', error);
    // Fallback
    setLocationEndString(`Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`);
    setLocationEndStringField(`Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`);
  }
};


  const handleCheckboxChange = (event) => {
    const { value } = event.target;
    if (daysSelected.includes(value)) {
      setDaysSelected((prevSelectedDays) =>
        prevSelectedDays.filter((day) => day !== value)
      );
    } else {
      setDaysSelected((prevSelectedDays) => [...prevSelectedDays, value]);
    }
  };

  const handleDateChange = (newDate) => {
    if (newDate) {
      const newDateObject = dayjs(newDate);
      setSelectedDate(newDateObject);
    }
  };

  const handleCnicFront = (e) => {
    const file = e.target.files[0];
    const maxSize = 5120000;
    if (file) {
      if (file.size <= maxSize) {
        const reader = new FileReader();
        reader.onload = () => {
          setCnicFront(reader.result.split(",")[1]);
          setCnicFrontExt(file.name.split(".").pop());
        };
        reader.readAsDataURL(file);
      } else {
        displayNotification("error", "Your file exceeds 5MB");
        setTimeout(() => {
          e.target.value = null;
          setCnicFront(null);
          setCnicFrontExt(null);
        }, 100);
      }
    }
  };

  const handleCnicBack = (e) => {
    const file = e.target.files[0];
    const maxSize = 5120000;
    if (file) {
      if (file.size <= maxSize) {
        const reader = new FileReader();
        reader.onload = () => {
          setCnicBack(reader.result.split(",")[1]);
          setCnicBackExt(file.name.split(".").pop());
        };
        reader.readAsDataURL(file);
      } else {
        displayNotification("error", "Your file exceeds 5MB");
        setTimeout(() => {
          e.target.value = null;
          setCnicBack(null);
          setCnicBackExt(null);
        }, 100);
      }
    }
  };

  const handlePicture = (e) => {
    const file = e.target.files[0];
    const maxSize = 5120000;
    if (file) {
      if (file.size <= maxSize) {
        const reader = new FileReader();
        reader.onload = () => {
          setPicture(reader.result.split(",")[1]);
          setPictureExt(file.name.split(".").pop());
        };
        reader.readAsDataURL(file);
      } else {
        displayNotification("error", "Your file exceeds 5MB");
        setTimeout(() => {
          e.target.value = null;
          setPicture(null);
          setPictureExt(null);
        }, 100);
      }
    }
  };

  const handleShowStartModal = () => {
    setShowStartModal(true);
  };

  const handleCloseStartModal = () => {
    if (markerPositionStart.lat === null && markerPositionStart.lng === null) {
      displayNotification(
        "warning",
        "Please select a Starting Location from Map"
      );
    } else {
      setShowStartModal(false);
    }
  };

  const handleShowEndModal = () => {
    setShowEndModal(true);
  };

  const handleCloseEndModal = () => {
    if (markerPositionEnd.lat === null && markerPositionEnd.lng === null) {
      displayNotification(
        "warning",
        "Please select a Drop-off Location from Map"
      );
    } else {
      setShowEndModal(false);
    }
  };

  const handleLogin = async () => {
    const requiredFields = [
      cityStartId,
      provinceStartId,
      locationStartString,
      markerPositionStart,
      cityEndId,
      provinceEndId,
      locationEndString,
      markerPositionEnd,
      selectedHomeTime,
      selectedOfficeTime,
      gender,
      preferredGender,
    ];
    const isValid = requiredFields.every((field) => {
      if (field === markerPositionStart || field === markerPositionEnd) {
        return field.lat !== null && field.lng !== null;
      }
      return field !== "" && field !== null && field !== undefined;
    });
    if (daysSelected.length === 0) {
      displayNotification("error", "Please select at least one commuting day");
      return;
    }
    if (!isValid) {
      setValidated(true);
      displayNotification("error", "Please fill all required fields");
      return;
    }
    if (
      locationStartString === locationEndString ||
      (markerPositionStart.lat === markerPositionEnd.lat &&
        markerPositionStart.lng === markerPositionEnd.lng)
    ) {
      displayNotification("error", "Please select different starting and drop-off point");
      return;
    }
    setIsLoading(true);
    try {
      await PersonalForm();
      await LocationForm();
      displayNotification("success", "Rider Registration Form Submitted successfully");
      navigate("/dashboard");
    } catch (error) {
      displayNotification("error", "Submission failed. Please try again.");
      console.error("API call error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const PersonalForm = async () => {
    try {
      const body = {
        gender: gender,
        preferred_gender: preferredGender,
        user_type: 299,
      };
      const response = await fetch(`${API_URL}/api/v1/registration/personal`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify(body),
      });
      const jsonresponse = await response.json();
      if (jsonresponse.statusCode == 200) {
        console.log("Personal Form Response:", jsonresponse);
      } else if (jsonresponse.statusCode === 422) {
        const errors = jsonresponse.errors;
        for (const field of Object.keys(errors)) {
          displayNotification("error", `${errors[field][0]}`);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const LocationForm = async () => {
    try {
      let nameArrayStart = [markerPositionStart.lat, markerPositionStart.lng];
      const myStringStart = nameArrayStart.toString();
      let nameArrayEnd = [markerPositionEnd.lat, markerPositionEnd.lng];
      const myStringEnd = nameArrayEnd.toString();
      const body = {
        option: 0,
        user_type: 299,
        university_name: null,
        university_address: null,
        veh_option: 0,
        start_point: {
          city_id: cityStartId,
          province_id: provinceStartId,
          area_id: locationStartStringId,
          area_google: {
            name: locationStartString,
            place_id: locationStartStringId || "ddChIJGQ_wq43t3zgRel4CwxgjgQs",
          },
          name: myStringStart,
        },
        end_point: {
          city_id: cityEndId,
          province_id: provinceEndId,
          area_id: locationEndStringId,
          area_google: {
            name: locationEndString,
            place_id: locationEndStringId || "ChIJGQ_wq43t3zgRel4CwxgjgQs",
          },
          name: myStringEnd,
        },
        time: {
          start_time_id: selectedHomeTime,
          return_time_id: selectedOfficeTime,
        },
        days: daysSelected,
      };
      const response = await fetch(`${API_URL}/api/v1/registration/location`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify(body),
      });
      const jsonresponse = await response.json();
      if (jsonresponse.statusCode == 200) {
        console.log("Location Form Response:", jsonresponse);
      } else {
        displayNotification("error", `${jsonresponse.message}`);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const AddNewStart = () => {
    setAddNewStart(true);
    setAddNewStartDropdown(false);
    setAddNewStartField(false);
  };

  const AddNewEnd = () => {
    setAddNewEnd(true);
    setAddNewEndDropdown(false);
    setAddNewEndField(false);
  };

  return (
    <>
      <div className="main-bg">
        <div className="containter p-5 position-relative">
          <div className="area">
            <ul className="circles">
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div>
          <div className="row justify-content-center ">
            <div className="col-md-6 shadow bg-white mt-5 mb-5">
              <div className="row shadow form-color-header">
                <h1 className="text-center text-yellow py-4"> 
                  Registration Form
                </h1>
              </div>
              <Form
                className=" p-3"
                noValidate
                validated={validated}
                onSubmit={handleSubmit}
              >
                <div className="row mb-3 shadow shadow-sm">
                  <div className="col-md-12 px-2 py-3 form-color-field">
                    <Form.Group
                      as={Col}
                      md="12"
                      controlId="validationCustom13"
                      className="mb-2"
                    >
                      <Form.Label className="fs-6 text-black">
                        I am
                      </Form.Label>
                      <Form.Select
                      aria-label="Default select example"
                      className="text-white"
                      value={gender}
                      onChange={(e) => setGender(e.target.value)}
                      required
                      style={{
                      backgroundColor: "#01183F",
                      border: "2px solid #FFC738",
                      color: "#fff",
                      }}
                      >
                        <option value="" hidden>
                          {" "}
                          Gender{" "}
                        </option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </Form.Select>
                    </Form.Group>
                  </div>
                </div>
                <div className="row mb-3 shadow shadow-sm">
                  <div className="col-md-12 px-2 py-3 form-color-field">
                    <Form.Group
                      as={Col}
                      md="12"
                      controlId="validationCustom14"
                      className="mb-2"
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Form.Label className="fs-6 text-black">
                          Preferred Gender of Travel Partner
                        </Form.Label>
                        <p
                          className="colorplace text-danger"
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        >
                          <Tooltip
                            title={
                              <h6 className="px-2">
                                {
                                  "You can choose the gender of your travel partner based on your comfort level."
                                }
                              </h6>
                            }
                          >
                            <Link
                              className="mx-1 h-15px d-inline-block"
                              style={{ cursor: "pointer" }}
                            >
                              <i className="fa-solid fs-4 fa-circle-info icon-tooltip-blue"></i>
                            </Link>
                          </Tooltip>
                        </p>
                      </div>
                      <Form.Select
                        aria-label="Default select example"
                        className="text-white"
                        value={preferredGender}
                        onChange={(e) => setPreferredGender(e.target.value)}
                        required
                      style={{
                      backgroundColor: "#01183F",
                      border: "2px solid #FFC738",
                      color: "#fff",
                      }}
                      >
                        <option value="" hidden>
                          Preferred Gender
                        </option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Both">Both</option>
                      </Form.Select>
                    </Form.Group>
                  </div>
                </div>
                <div className="row mb-3 shadow shadow-sm">
                  <div className="col-md-12 px-2 py-3 form-color-field">
                    <h2 className="text-yellow mb-3 text-center">
                      STARTING POINT
                      <Tooltip
                        title={
                          <h6 className="px-2">
                            {
                              "You have the option to choose your starting or pickup location using Google Map, which becomes accessible once you have selected your province, city and area."
                            }
                          </h6>
                        }
                      >
                        <Link
                          className="mx-1 h-15px d-inline-block"
                          style={{ cursor: "pointer" }}
                        >
                          <i className="fa-solid fs-4 fa-circle-info icon-tooltip-blue"></i>
                        </Link>
                      </Tooltip>
                    </h2>
                    <Form.Group
                      as={Col}
                      md={cityStartId ? "12" : "12"}
                      controlId="validationCustom01"
                      className="mb-2"
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Form.Label className="text-black fs-6">
                          Province
                        </Form.Label>
                        <p
                          className="colorplace text-danger"
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        ></p>
                      </div>
                      <Form.Select
                      aria-label="Default select example"
                      className="text-white"
                      value={provinceStartId}
                      onChange={handleProvinceStartChange}
                      required
                      style={{
                      backgroundColor: "#01183F",
                      border: "2px solid #FFC738",
                      color: "#fff",
                      }}
                      >
                        <option value="" hidden>
                          Select a Province
                        </option>
                        {dropdownStartdata?.countries[0]?.provinces?.map(
                          (province) => (
                            <option key={province.id} value={province.id}>
                              {province.value}
                            </option>
                          )
                        )}
                      </Form.Select>
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md={cityStartId ? "12" : "12"}
                      controlId="validationCustom02"
                      className="mb-2"
                    >
                      <Form.Label className="text-black fs-6">City</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        className="text-white"
                        value={cityStartId}
                        onChange={(e) => {
                          const selectedOption =
                            e.target.options[e.target.selectedIndex];
                          const selectedValue = selectedOption.value;
                          const selectedId =
                            selectedOption.getAttribute("data-id");
                          setCityStartId(selectedValue);
                          setCityStart(selectedId);
                          setAddNewStartDropdown(true);
                          setAddNewStart(false);
                          setAddNewStartField(true);
                          setStartSuggestions([]);
                        }}
                        required
                        style={{
                          backgroundColor: "#01183F",
                          border: "2px solid #FFC738",
                          color: "#fff",
                        }}
                      >
                        <option value="" hidden>
                          Select a City
                        </option>
                        {selectedStartProvinceCities?.map((province) => (
                          <option
                            key={province.id}
                            value={province.id}
                            data-id={province.value}
                          >
                            {province.value}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                    {cityStartId && (
                      <Form.Group
                        as={Col}
                        md="12"
                        controlId="validationCustom05"
                      >
                        <Form.Label className="text-black">Area</Form.Label>
                        <Form.Control
                          autoComplete="off"
                          required
                          type="text"
                          value={locationStartStringField}
                          onChange={handleLocationStartField}
                          className="text-white mt-1"
                          placeholder={`Enter area in ${cityStart}`}
                          style={{
                            backgroundColor:"#01183F",
                            border:"2px solid #FFC738",
                            color:"#fff"
                          }}
                        />
                        {startSuggestions.length > 0 && (
                          <ul className="list-group mt-2" style={{ maxHeight: "200px", overflowY: "auto" }}>
                            {startSuggestions.map((suggestion, index) => (
                              <li
                                key={index}
                                className="list-group-item list-group-item-action"
                                onClick={() => handleSuggestionSelect(suggestion, true)}
                              >
                                {suggestion.description}
                              </li>
                            ))}
                          </ul>
                        )}
                      </Form.Group>
                    )}
                  </div>
                </div>
                <div className="row mb-3 shadow shadow-sm">
                  <div className="col-md-12 px-2 py-3 form-color-field">
                    <h2 className="text-yellow mb-3 text-center">
                      DROP-OFF POINT
                      <Tooltip
                        title={
                          <h6 className="px-2">
                            {
                              "You have the option to choose your drop-off location using Google Map, which becomes accessible once you've selected your province, city and area."
                            }
                          </h6>
                        }
                      >
                        <Link
                          className="mx-1 h-15px d-inline-block"
                          style={{ cursor: "pointer" }}
                        >
                          <i className="fa-solid fs-4 fa-circle-info icon-tooltip-blue"></i>
                        </Link>
                      </Tooltip>
                    </h2>
                    <Form.Group
                      as={Col}
                      md={cityEndId ? "12" : "12"}
                      controlId="validationCustom07"
                      className="mb-2"
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Form.Label className="text-black fs-6">
                          Province
                        </Form.Label>
                        <p
                          className="colorplace text-danger"
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        ></p>
                      </div>
                      <Form.Select
                      aria-label="Default select example"
                      className="text-white"
                      value={provinceEndId}
                      onChange={handleProvinceEndChange}
                      required
                      style={{
                      backgroundColor: "#01183F",
                      border: "2px solid #FFC738",
                      color: "#fff",
                      }}
                      >
                        <option value="" hidden>
                          Select a Province
                        </option>
                        {dropdownEnddata?.countries[0]?.provinces?.map(
                          (province) => (
                            <option key={province.id} value={province.id}>
                              {province.value}
                            </option>
                          )
                        )}
                      </Form.Select>
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md={cityEndId ? "12" : "12"}
                      controlId="validationCustom02"
                      className="mb-2"
                    >
                      <Form.Label className="text-black fs-6">City</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        className="text-white"
                        value={cityEndId}
                        onChange={(e) => {
                          const selectedOption =
                            e.target.options[e.target.selectedIndex];
                          const selectedValue = selectedOption.value;
                          const selectedId =
                            selectedOption.getAttribute("data-id");
                          setCityEndId(selectedValue);
                          setCityEnd(selectedId);
                          setAddNewEndDropdown(true);
                          setAddNewEnd(false);
                          setAddNewEndField(true);
                          setEndSuggestions([]);
                        }}
                        required
                        style = {{
                          backgroundColor: "#01183F",
                          border : "2px solid #FFC738",
                          color : "#fff",
                        }}
                      >
                        <option value="" hidden>
                          Select a City
                        </option>
                        {selectedEndProvinceCities?.map((province) => (
                          <option
                            key={province.id}
                            value={province.id}
                            data-id={province.value}
                          >
                            {province.value}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                    {cityEndId && (
                      <Form.Group
                        as={Col}
                        md="12"
                        controlId="validationCustom11"
                      >
                        <Form.Label className="text-black">Area</Form.Label>
                        <Form.Control
                          autoComplete="off"
                          required
                          type="text"
                          value={locationEndStringField}
                          onChange={handleLocationEndField}
                          className="text-white mt-1"
                          placeholder={`Enter area in ${cityEnd}`}
                          style={{
                            backgroundColor:"#01183F",
                            border:"2px solid #FFC738",
                            color:"#fff"
                          }}
                        />
                        {endSuggestions.length > 0 && (
                          <ul className="list-group mt-2" style={{ maxHeight: "200px", overflowY: "auto"}}>
                            {endSuggestions.map((suggestion, index) => (
                              <li
                                key={index}
                                className="list-group-item list-group-item-action"
                                onClick={() => handleSuggestionSelect(suggestion, false)}
                              >
                                {suggestion.description}
                              </li>
                            ))}
                          </ul>
                        )}
                      </Form.Group>
                    )}
                  </div>
                </div>
                <Modal show={showStartModal} onHide={handleCloseStartModal}>
                  <Modal.Header className="d-block">
                    <Modal.Title>Select Starting Location</Modal.Title>
                    <Modal.Title className="text-danger fs-7">
                      To get maximum suggestions/matches please select
                      prominent landmark or community/society gate as a
                      pickup point
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Container className="d-flex justify-content-center align-items-center mb-3">
                      <Row style={{ height: "100%", width: "100%" }}>
                        <GoogleMap
                          zoom={15}
                          center={defaultStartCenter}
                          mapContainerStyle={{
                            width: "100%",
                            height: "50vh",
                          }}
                          onClick={handleMapClickStart}
                          options={{
                            componentRestrictions: { country: "PK" },
                          }}
                        >
                          <MarkerF
                            position={markerPositionStart}
                            icon={{
                              url: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
                            }}
                          />
                        </GoogleMap>
                      </Row>
                    </Container>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="contained"
                      onClick={handleCloseStartModal}
                      className="btn-custom1 mx-2 border-0 px-4 py-2 rounded rounded-2 text-white fw-bold"
                    >
                      Select
                    </Button>
                  </Modal.Footer>
                </Modal>
                <Modal show={showEndModal} onHide={handleCloseEndModal}>
                  <Modal.Header className="d-block">
                    <Modal.Title>Select Drop-off Location</Modal.Title>
                    <Modal.Title className="text-danger fs-7">
                      If you do not want to give your exact location please
                      choose your nearest landmark?
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Container className="d-flex justify-content-center align-items-center mb-3">
                      <Row style={{ height: "100%", width: "100%" }}>
                        <GoogleMap
                          zoom={15}
                          center={defaultEndCenter}
                          mapContainerStyle={{
                            width: "100%",
                            height: "50vh",
                          }}
                          onClick={handleMapClickEnd}
                          options={{
                            componentRestrictions: { country: "PK" },
                          }}
                        >
                          <MarkerF
                            position={markerPositionEnd}
                            icon={{
                              url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
                            }}
                          />
                        </GoogleMap>
                      </Row>
                    </Container>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="contained"
                      onClick={handleCloseEndModal}
                      className="btn-custom1 mx-2 border-0 px-4 py-2 rounded rounded-2 text-white fw-bold"
                    >
                      Select
                    </Button>
                  </Modal.Footer>
                </Modal>
                <div className="row mb-3 shadow shadow-sm">
                  <div className="col-md-12 px-2 py-3 form-color-field">
                    <h2 className="text-yellow mb-3 text-center">Timing</h2>
                    <Form.Group
                      as={Col}
                      md="12"
                      controlId="validationCustomtime1"
                      className="mb-2 mt-3"
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Form.Label className="text-black fs-6">
                          Start Time
                        </Form.Label>
                        <p
                          className="colorplace text-danger"
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        >
                          <Tooltip
                            title={
                              <h6 className="px-2">
                                {
                                  "You can specify the times you are available for commuting by selecting both the start and return times."
                                }
                              </h6>
                            }
                          >
                            <Link
                              className="mx-1 h-15px d-inline-block"
                              style={{ cursor: "pointer" }}
                            >
                              <i className="fa-solid fs-4 fa-circle-info icon-tooltip-blue"></i>
                            </Link>
                          </Tooltip>
                        </p>
                      </div>
                      <Form.Select
                        aria-label="Default select example"
                        className="text-white"
                        value={selectedHomeTime}
                        onChange={(e) => {
                          const selectedOption =
                            e.target.options[e.target.selectedIndex];
                          const selectedValue = selectedOption.value;
                          const selectedId =
                            selectedOption.getAttribute("data-id");
                          setSelectedHomeTime(selectedValue);
                          setSelectedHomeTimeValue(selectedId);
                        }}
                        required
                        style = {{
                          backgroundColor : "#01183F",
                          border: "2px solid #FFC738",
                          color: "#fff",
                        }}
                      >
                        <option value="" hidden>
                          Start Time
                        </option>
                        {homeTimeSlots?.map((time) => (
                          <option
                            key={time.id}
                            value={time.id}
                            data-id={time.time_string}
                          >
                            {time.time_string}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="12"
                      controlId="validationCustomtime2"
                      className="mb-2 mt-3"
                    >
                      <Form.Label className="text-black fs-6">
                        Return Time
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        className="text-white"
                        value={selectedOfficeTime}
                        onChange={(e) => setSelectedOfficeTime(e.target.value)}
                        required
                        style={{
                        backgroundColor: "#01183F",
                        border: "2px solid #FFC738",
                        color: "#fff",
                        }}

                      >
                        <option value="" hidden>
                          Return Time
                        </option>
                        {filteredOfficeTimeSlots?.map((time) => (
                          <option key={time.id} value={time.id}>
                            {time.time_string}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </div>
                </div>
                <Row className="mb-3 px-3 form-color-field">
                  <Form.Group as={Col} md="12" controlId="validationCustom20">
                    <Form.Label style={{ color: "#000" }} className="pt-3 px-3">
                      I Commute (Select Days)
                    </Form.Label>
                  </Form.Group>
                  <div className="row d-flex px-4">
                    <div className="col">
                      {["checkbox"].map((type) => (
                        <div
                          key={`inline-${type}`}
                          className="mb-3 d-flex flex-wrap"
                        >
                          <FormControlLabel
                            control={
<Checkbox
  name="group1"
  value="Monday"
  className="custom-checkbox"
  checked={daysSelected.includes("Monday")}
  onChange={handleCheckboxChange}
/>
                            }
                            label="Monday"
                              sx={{
    "& .MuiFormControlLabel-label": {
      color: "#000",
    },
  }}
                          />
                          <FormControlLabel
                            control={
<Checkbox
  name="group1"
  value="Tuesday"
  className="custom-checkbox"
  checked={daysSelected.includes("Tuesday")}
  onChange={handleCheckboxChange}
/>
                            }
                            label="Tuesday"
                              sx={{
    "& .MuiFormControlLabel-label": {
      color: "#000",
    },
  }}
                          />
                          <FormControlLabel
                            control={
<Checkbox
  name="group1"
  value="Wednesday"
  className="custom-checkbox"
  checked={daysSelected.includes("Wednesday")}
  onChange={handleCheckboxChange}
/>
                            }
                            label="Wednesday"
                              sx={{
    "& .MuiFormControlLabel-label": {
      color: "#000",
    },
  }}
                          />
                          <FormControlLabel
                            control={
<Checkbox
  name="group1"
  value="Thursday"
  className="custom-checkbox"
  checked={daysSelected.includes("Thursday")}
  onChange={handleCheckboxChange}
/>
                            }
                            label="Thursday"
                              sx={{
    "& .MuiFormControlLabel-label": {
      color: "#000",
    },
  }}
                          />
                          <FormControlLabel
                            control={
<Checkbox
  name="group1"
  value="Friday"
  className="custom-checkbox"
  checked={daysSelected.includes("Friday")}
  onChange={handleCheckboxChange}
/>
                            }
                            label="Friday"
                              sx={{
    "& .MuiFormControlLabel-label": {
      color: "#000",
    },
  }}
                          />
                          <FormControlLabel
                            control={
<Checkbox
  name="group1"
  value="Saturday"
  className="custom-checkbox"
  checked={daysSelected.includes("Saturday")}
  onChange={handleCheckboxChange}
/>
                            }
                            label="Saturday"
                              sx={{
    "& .MuiFormControlLabel-label": {
      color: "#000",
    },
  }}
                          />
                          <FormControlLabel
                            control={
<Checkbox
  name="group1"
  value="Sunday"
  className="custom-checkbox"
  checked={daysSelected.includes("Sunday")}
  onChange={handleCheckboxChange}
/>
                            }
                            label="Sunday"
                              sx={{
    "& .MuiFormControlLabel-label": {
      color: "#000",
    },
  }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </Row>
                <div
                  className="alert alert-info alert-dismissible fade show"
                  role="alert"
                >
                  <h6 className="text-left d-flex">
                    <i className="fa-solid fa-lock fa-fw text-danger text-center pe-3"></i>
                    <li className="text-danger" style={{ listStyle: "none" }}>
                      Your data is protected within a secured environment.
                    </li>
                  </h6>
                  <button
                    type=""
                    className="btn-close"
                    data-bs-dismiss="alert"
                    aria-label="Close"
                  ></button>
                </div>
                <Stack
                  direction="row"
                  className="mb-4"
                  spacing={2}
                  style={{ justifyContent: "right" }}
                >
                  <Button
                    variant="outlined"
                    size="large"
                    className="btn-custom1 mx-2 border-0 px-4 py-2 rounded rounded-2 text-white fw-bold"
                    onClick={handleLogin}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <span>
                        <i className="fa fa-spinner fa-spin" /> Submitting...
                      </span>
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </Stack>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RiderRegistration;